import React from 'react'
import {
  getAppointmentStatusByCode,
  getAppointmentStatusByName,
} from '../Utils/appointmentStatusUtils'

type Props = {
  statusName?: string | null
  status?: number | null
  className?: string
}

export function AppointmentStatusBadge({statusName, status, className = ''}: Props) {
  const {label, color} = statusName
    ? getAppointmentStatusByName(statusName)
    : getAppointmentStatusByCode(status)

  if (!statusName && (status === undefined || status === null)) return null

  const isCanceled = statusName === 'Canceled' || status === 6

  return (
    <span
      className={`badge fw-bolder rounded-pill px-3 py-2 fs-7 ${className}`}
      style={{
        backgroundColor: color,
        color: isCanceled ? 'black' : 'white',
      }}
      aria-label={`Appointment status: ${label}`}
    >
      {label}
    </span>
  )
}
